import { TENANT_ID } from './config';

export const DB_PATH = 'projects/db.json';

// Function names for dynamic routing
export const FUNCTION_NAMES = {
  GET: {
    GET_PROJECTS: 'getProjects',
    GET_PROJECT: 'getProject',
    GET_TOUR: 'getTour',
    GET_TOURS: 'getTours',
    GET_PUBLIC_LINKS: 'getPublicLinks',
  },
  POST: {
    LIST_S3_KEYS: 'listKeys',
    GET_S3_KEY: 'getS3Key',
    DELETE_S3_KEY: 'deleteS3Key',
    SAVE_PROJECT: 'saveProject',
    SAVE_TOUR: 'saveTour',
    UPLOAD_FILE: 'uploadFile',
    CREATE_THUMBNAILS: 'createThumbnails',
    GENERATE_UPLOAD_URL: 'generateUploadUrl',
    CREATE_PUBLIC_LINK: 'createPublicLink',
    TOGGLE_PUBLIC_LINK: 'togglePublicLink',
    CREATE_USER_WITH_EMAIL: 'createUserWithEmail',
    PUSH_TO_PRIORITY: 'pushToPriority',
    PROCESS_BATCH_DEPTH: 'PROCESS_BATCH_DEPTH',
    GET_PRESIGNED_URL: 'getPresignedUrl',
    GET_VIDEO_H264: 'getVideoH264',
    CHECK_BATCH_STATUS: 'CHECK_BATCH_STATUS',
    GET_DEPTH_COORDINATES: 'GET_DEPTH_COORDINATES',
    PROCESS_SYNC_TOURS: 'PROCESS_SYNC_TOURS',
    SAVE_UPLOADED_FILES: 'SAVE_UPLOADED_FILES', // Tidharm upload flow
    VERIFY_SPACE_ACCESS: 'verifySpaceAccess',
    ADMIN_CHANGE_PASSWORD: 'adminChangePassword',
    // Service Calls Dashboard (Bedek) endpoints
    SERVICE_CALLS_PROXY: 'serviceCallsProxy',
    SERVICE_CALLS_OPEN: 'serviceCallsOpen',
    TRACER_PROXY: 'tracerProxy',
    GET_TECH_CAR_MAPPING: 'getTechCarMapping',
  },
  PRISMA: 'PRISMA',
};

export const ROOM_OPTIONS = [
  'דלת כניסה',
  'מתזים סלון',
  'ברז מטבח',
  'סיפון מטבח',
  'ברז גן במרפסת',
  'ברז ניל במרפסת',
  'שירותי אורחים',
  'מסתור כביסה',
  'מחלקי מים לדירה',
  'מתזים במסדרון',
  'מקלחת הורים',
  'מקלחת חדר מתבגר',
];

// Tenant-aware constants
export const BUCKET_NAME_PHOTOS = TENANT_ID === 'tidharm' ? 'tidharm-raw' : 'agamim-virtual-tour';
export const CONSTANT_PROJECT_ID = `${TENANT_ID}-virtual-tour-projectId`;
